const {
  getValue
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.source, content, parentContentPath, transientContext, nativeFunctions);
  if (values === undefined) {
    return undefined;
  }
  const comparator = path => (a, b) => {
    const x = path ? getValue(path, a) : a;
    const y = path ? getValue(path, b) : b;
    if (typeof x === typeof y) {
      return x < y ? -1 : 1;
    }
    if (typeof x === 'number' && typeof y === 'string') {
      return -1;
    }
    if (typeof x === 'string' && typeof y === 'number') {
      return 1;
    }
    return 0;
  };
  const sortBy = await evaluateSource(source.sortBy, content, parentContentPath, nativeFunctions);
  values.sort(comparator(sortBy));
  const ascending = await evaluateSource(source.ascending, content, parentContentPath, nativeFunctions);
  if (ascending === false) {
    values.reverse();
  }
  return values;
};
module.exports = {
  evaluate
};